export default __webpack_public_path__ + "static/media/church-bell.161a91d5.ogg";